import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "list-group list-group-flush" }
const _hoisted_4 = { class: "list-group-item d-flex justify-content-between align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-paragraph" }, "Status", -1)
const _hoisted_6 = { class: "list-group-item d-flex justify-content-between align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-paragraph" }, " Tipo de sessão", -1)
const _hoisted_8 = { class: "text-subtitle" }
const _hoisted_9 = { class: "list-group-item d-flex justify-content-between align-items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-paragraph" }, "Dia", -1)
const _hoisted_11 = { class: "text-subtitle" }
const _hoisted_12 = { class: "list-group-item d-flex justify-content-between align-items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-paragraph" }, "Horário", -1)
const _hoisted_14 = { class: "text-subtitle" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("li", { class: "list-group-item d-flex justify-content-between align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-paragraph" }, "Duração"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-subtitle" }, "50 minutos")
], -1)
const _hoisted_16 = {
  key: 0,
  class: "list-group-item d-flex justify-content-between align-items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", {
              class: _normalizeClass(["text-subtitle", _ctx.item?.status_color])
            }, [
              _createTextVNode(_toDisplayString(_ctx.item?.status_label) + " ", 1),
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.item?.status_icon)
              }, null, 2)
            ], 2)
          ]),
          _createElementVNode("li", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.item?.formatted_type), 1)
          ]),
          _createElementVNode("li", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.item?.formatted_date), 1)
          ]),
          _createElementVNode("li", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("span", _hoisted_14, "das " + _toDisplayString(_ctx.item?.formatted_time), 1)
          ]),
          _hoisted_15,
          (_ctx.item.can_reschedule)
            ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                _createVNode(_component_Button, {
                  outline: "",
                  fullWidth: "",
                  label: "Reagendar sessão",
                  onOnClick: _ctx.handleReschedule
                }, null, 8, ["onOnClick"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}